import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

const SITE_NAME = 'GameMeetsWorld';
const SITE_URL = 'https://gamemeetsworld.com';
const DEFAULT_IMAGE = `${SITE_URL}/og-image.jpg`;

export default function Seo({
  title,
  description,
  path = '',
  image = DEFAULT_IMAGE,
  noIndex = false,
  breadcrumbs = [],
  structuredData = []
}) {
  const location = useLocation();
  const canonicalPath = path || `${location.pathname}${location.search}`;
  const canonical = `${SITE_URL}${canonicalPath}`;
  const fullTitle = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
  const robots = noIndex ? 'noindex, nofollow' : 'index, follow';
  const breadcrumbSchema = breadcrumbs.length
    ? {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: breadcrumbs.map((crumb, idx) => ({
        '@type': 'ListItem',
        position: idx + 1,
        name: crumb.name,
        item: `${SITE_URL}${crumb.path}`
      }))
    }
    : null;
  const allSchemas = [
    ...(breadcrumbSchema ? [breadcrumbSchema] : []),
    ...structuredData
  ];

  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      <meta name="robots" content={robots} />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      {allSchemas.map((schema, idx) => (
        <script key={idx} type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  );
}
